const actions = {
    FETCH_PRE_ROUTINES: 'FETCH_PRE_ROUTINES',
    FETCH_PRE_ROUTINE: 'FETCH_PRE_ROUTINE',
    RESET_PRE_ROUTINE: 'RESET_PRE_ROUTINE',

    fetchPreRoutinesAction: (data) => {
        return {
            type: actions.FETCH_PRE_ROUTINES,
            data: data
        };
    },
    resetPreRoutineFormAction: () => {
        return {
            type: actions.RESET_PRE_ROUTINE,
            data: null
        };
    },
    fetchPreRoutineAction: (data) => {
        return {
            type: actions.FETCH_PRE_ROUTINE,
            data: data
        };
    }
};

export default actions;
